import React from "react";
import { Drawer } from "@mui/material";
import DrawerHeader from "../../shared/helpers/DrawerHeader.js";
import DrawerFooterContainerSmall from "../../shared/helpers/DrawerFooterContainerSmall.js";
import ButtonFilled from "../../shared/helpers/ButtonFilled.js";
import StatusWithText from "../../shared/helpers/StatusWithText.js";
import ModalInfoCard from "../../shared/helpers/ModalInfoCard.js";
import ModalUserStatusCard from "../../shared/helpers/ModalUserStatusCard.js";
import {
  formatDateReadable,
  formatTimestampDateReadable,
} from "../../utilities/helpers.js";
import { get_t_str } from "../../../../../helpers/helpers.js";
import {
  CalendarToday,
  DescriptionOutlined,
  ChatBubbleOutline,
  Send,
  CheckCircle,
  AccessTime,
  LocalOfferOutlined,
  PersonOutline
} from '@mui/icons-material';

const TimeOffApprovedDrawer = (props) => {
  const toggleDrawer = (open) => (event) => {
    if (
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }
    props.setDrawerOpen(open);
  };

  return (
    <Drawer anchor="right" open={props.isDrawerOpen} onClose={toggleDrawer(false)} sx={props.sx || {}}>
      <div className="w-[450px] h-screen bg-white relative">
        <div className="max-h-screen overflow-auto">
          <DrawerHeader
            title="Time off request"
            onClose={toggleDrawer(false)}
          />
          <div className="px-6 py-5">
            {/* User Status Section */}
            <div className="mb-6">
              <ModalUserStatusCard
                status={props.requestInfo.status.toLowerCase()}
                name={`${props.requestInfo.firstName} ${props.requestInfo.lastName}`}
              />
            </div>

            {/* Info Cards */}
            <div className="w-full">
              <div className="mb-4">
                <ModalInfoCard
                  icon={DescriptionOutlined}
                  title="Title"
                  value={props.requestInfo.title}
                />
              </div>

              {props.requestInfo.time_off_type && (
                <div className="mb-4">
                  <ModalInfoCard
                    icon={LocalOfferOutlined}
                    title="Type"
                    value={
                      props.requestInfo.time_off_type === 'UNPAID' ? 'Unpaid' :
                      props.requestInfo.time_off_type === 'PTO' ? 'Paid Time Off (PTO)' :
                      props.requestInfo.time_off_type === 'SICK' ? 'Sick Leave' :
                      'Not specified'
                    }
                  />
                </div>
              )}

              <div className="mb-4">
                <ModalInfoCard
                  icon={CalendarToday}
                  title="Time Off Period"
                  value={`${formatDateReadable(props.requestInfo.startDate)} ${props.requestInfo.endDate ? `- ${formatDateReadable(props.requestInfo.endDate)}` : ''}`}
                />
              </div>

              {props.requestInfo.startTime && props.requestInfo.endTime && (
                <div className="mb-4">
                  <ModalInfoCard
                    icon={AccessTime}
                    title="Time Off Partial Day"
                    value={`${get_t_str(props.requestInfo.startTime)} - ${get_t_str(props.requestInfo.endTime)}`}
                  />
                </div>
              )}

              {props.requestInfo.note && (
                <div className="mb-4">
                  <ModalInfoCard
                    icon={ChatBubbleOutline}
                    title="Employee Note"
                    value={props.requestInfo.note}
                  />
                </div>
              )}

              {props.requestInfo.managerNote && (
                <div className="mb-4">
                  <ModalInfoCard
                    icon={ChatBubbleOutline}
                    title="Manager Note"
                    value={props.requestInfo.managerNote}
                  />
                </div>
              )}

              <div className="flex flex-row items-start space-x-4">
                <div className="flex-1">
                  <ModalInfoCard
                    icon={Send}
                    title="Date Submitted"
                    value={formatTimestampDateReadable(props.requestInfo.dateSubmitted, props.storeTimezone)}
                  />
                </div>
                <div className="flex-1">
                  <ModalInfoCard
                    icon={CheckCircle}
                    title="Date Responded"
                    value={formatTimestampDateReadable(props.requestInfo.dateResponded, props.storeTimezone)}
                  />
                </div>
              </div>

              {props.requestInfo.actedBy && (
                <div className="mt-4">
                  <ModalInfoCard
                    icon={PersonOutline}
                    title="Responded By"
                    value={props.requestInfo.actedBy}
                  />
                </div>
              )}
            </div>
            <div className="h-[200px]"></div>
          </div>
        </div>
        <DrawerFooterContainerSmall>
          <div className="w-full">
            <ButtonFilled
              text="Close"
              onClick={toggleDrawer(false)}
            />
          </div>
        </DrawerFooterContainerSmall>
      </div>
    </Drawer>
  );
};

export default TimeOffApprovedDrawer;
